(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/router/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/app/router/assets/javascripts/prescript.js');
"use strict";


(svs => {
  svs.app = svs.app || {};
  svs.app.ReactRouter = svs.app.ReactRouter || {};
})(svs);

 })(window);